export const getProductFromPath = () => {
  const path = typeof window !== 'undefined' ? window.location?.pathname || '' : '';
  const pathParts = path.split('/');
  return pathParts[2]; // will be 'wlc'
};

export const isGettingStartedSlug = slug => typeof slug === 'string' && slug.toLowerCase() === 'getting-started';

export const createUserAnalytics = (contentItem, user) => ({
  service: 'weekly_guide',
  content_id: contentItem.id,
  slug: contentItem.slug,
  title: contentItem.title,
  uuid: user?.UUID
});

export const createAnalyticsContext = (base, additions) => ({
  ...base,
  ...additions
});
